module.exports = __webpack_public_path__ + "images/76e30816.rule_dark.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/images/rule_dark.webp
// module id = 4B7M
// module chunks = 12